import { generatePath, matchPath } from 'react-router-dom';
import * as constants from 'app-constants';

export default {
  pathFeatures: (appId) => {
    if (!appId) {
      return '/';
    }
    return generatePath(constants.PATH_FEATURES, { appId });
  },
  pathFeaturesList: (appId, env) => {
    if (!appId || !env) {
      return '/';
    }
    return generatePath(constants.PATH_FEATURES_LIST, { appId, env });
  },
  currentPathWithNewEnv: (env) => {
    const [, locationPath] = window.location.pathname.split(
      constants.PATH_BASE
    );

    let targetPath;
    constants.PATH_WITH_ENV.find((path) => {
      const match = matchPath(locationPath, {
        path,
        exact: true,
        strict: false
      });
      if (match && match.params.env) {
        targetPath = generatePath(path, { ...match.params, ...{ env } });
        return true;
      }
      return false;
    });
    return targetPath;
  }
};
